import { call, fork, select,  takeLatest } from 'redux-saga/effects';

import { fetchNotifications } from '../api';

import { notificationListActions } from './actions';
import { getNotificationListById, getCurrentNotificationList } from './selectors';

export function* loadNotificationList({payload}) {
  const { notificationListId, sessionId } = payload;
  const notificationList = yield select(getNotificationListById, notificationListId);
  if (notificationList && !notificationList.isPending ) {
    yield call( fetchNotifications, notificationListId, { notificationId: notificationListId, sessionId });
  }
}


//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadNotificationList() {
  yield takeLatest(notificationListActions.LOAD_NOTIFICATIONS, loadNotificationList);
}

//=====================================
//  ROOT
//-------------------------------------

export const notificationListSagas = [
  fork(watchLoadNotificationList),
];
